import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { TextField } from '@front/squirtle/'

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField
        name={'waiting_minute_rate'}
        label={I18n.t('quotation.waiting_minute_rate')}
        type='number'
        InputProps={{
          endAdornement: I18n.t('minute.label.short'),
          inputProps: { style: { textAlign: 'right' } }
        }}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'included_waiting_minute'}
        label={I18n.t('quotation.including_waiting_minute')}
        type='number'
        InputProps={{
          endAdornement: I18n.t('fiat.eur.sign'),
          inputProps: { style: { textAlign: 'right' } }
        }}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'max_waiting_time'}
        label={I18n.t('quotation.max_waiting_time')}
        type='number'
        InputProps={{
          endAdornement: I18n.t('fiat.eur.sign'),
          inputProps: { style: { textAlign: 'right' } }
        }}
      />
    </Grid>
  </Grid>

const NoShow = props => <>
  <StepLabel>
    <Typography variant='h5'> {I18n.t('specificparameter.no_show')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
      <Grid container rowSpacing={2}>
        <Row1 {...props} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(NoShow)
